import './canyon/style';
import FormStructure from './canyon/form_structure';

export default FormStructure;